import { useState } from 'react';
import { useTranslation } from '../../i18n/i18n';
import { useConfig } from '../../config';
import axios from 'axios';
import { AlertMessages, useAlerts } from '../AlertMessages/AlertMessages';

export function ForgotPasswordButton({ email }: { email: string }) {
	const [successMsg, setSuccessMsg] = useState(false);
	const [loading, setLoading] = useState(false);
	const alerts = useAlerts();
	const { api } = useConfig();
	const t = useTranslation().form;

	async function forgotPassword(email: string) {
		setLoading(true);
		const res = await axios.post(`${api}forgot-password.json`, {
			email: email,
		});
		if (res.data.errors) {
			alerts.set({ type: 'error', message: res.data.errors.join(' ') });
			setLoading(false);
		} else if (res.data.success) {
			setSuccessMsg(true);
			setLoading(false);
		} else {
			alerts.set({ type: 'error', message: t.unexpectedError });
			setLoading(false);
		}
	}

	if (loading) return <IconLabel icon="/../images/ajax-loader-small.gif" label={t.sending} />;

	if (successMsg) return <IconLabel icon="/../images/green-check.webp" label={t.emailHasBeenSent} />;

	return (
		<div>
			<AlertMessages alerts={alerts} />
			<p>
				{t.forgotPassword}{' '}
				<button className="link" onClick={() => forgotPassword(email)}>
					{t.clickHere}
				</button>{' '}
				{t.emailNewPasswordLink}
			</p>
		</div>
	);
}

function IconLabel({ icon, label }: { icon: string; label: string }) {
	return (
		<p>
			<img src={icon} alt="" /> {label}
		</p>
	);
}
